import React, { createContext, useContext, useState } from 'react'

const RightSidebarContext = createContext({
    activeRightSidebar: null,
    sidebarData: null,
    openRightSidebar: (sidebarName, data) => {},
    closeRightSidebar: () => {},
    updateSidebarData: (data) => {},
})

export const useRightSidebar = () => {
    const context = useContext(RightSidebarContext)
    if (!context) {
        throw new Error('useRightSidebar must be used within RightSidebarProvider')
    }
    return context
}

export const RightSidebarProvider = ({ children }) => {
    const [activeRightSidebar, setActiveRightSidebar] = useState(null)
    const [sidebarData, setSidebarData] = useState(null)

    const openRightSidebar = (sidebarName, data = null) => {
        console.log('[RightSidebar] Opening:', sidebarName, 'with data:', data)
        setActiveRightSidebar(sidebarName)
        setSidebarData(data)
    }

    const closeRightSidebar = () => {
        console.log('[RightSidebar] Closing')
        setActiveRightSidebar(null)
        setSidebarData(null)
    }

    const updateSidebarData = (data) => {
        console.log('[RightSidebar] Updating data:', data)
        setSidebarData(prevData => ({ ...prevData, ...data }))
    }

    return (
        <RightSidebarContext.Provider
            value={{
                activeRightSidebar,
                sidebarData,
                openRightSidebar,
                closeRightSidebar,
                updateSidebarData,
            }}
        >
            {children}
        </RightSidebarContext.Provider>
    )
}
